import type { ReactNode } from "react";

interface EmptyStateProps {
  icon?: ReactNode | undefined;
  title: string;
  description?: string | undefined;
  action?: ReactNode | undefined;
  className?: string | undefined;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps): JSX.Element {
  return (
    <div
      className={cx(
        "flex flex-col items-center justify-center rounded-lg border border-dashed border-border p-8 text-center",
        className,
      )}
    >
      {icon !== undefined && <div className="mb-3 text-text-tertiary">{icon}</div>}
      <h2 className="text-base font-semibold text-text-primary">{title}</h2>
      {description !== undefined && (
        <p className="mt-2 max-w-sm text-sm leading-6 text-text-secondary">{description}</p>
      )}
      {action !== undefined && <div className="mt-5">{action}</div>}
    </div>
  );
}

function cx(...classes: Array<string | false | undefined>): string {
  return classes.filter(Boolean).join(" ");
}
